import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { DescriptionDetails, DescriptionList, DescriptionTerm } from '@/common/components/description-list';
import { Fieldset, Label, Legend } from '@/common/components/fieldset';
import { Heading } from '@/common/components/heading';
import { Radio, RadioField, RadioGroup } from '@/common/components/radio';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/common/components/tooltip';
import { PenIcon } from '@/icons/fa/regular';

export const Route = createFileRoute('/applications/$application-id/consent')({
  component: RouteComponent
});

function RouteComponent() {
  const handleNameChange = () => {
  };

  return (
    <div className="p-8">
      <Heading>Identity and Credit Check</Heading>

      <DescriptionList>
        <DescriptionTerm>Full Legal Name</DescriptionTerm>
        <DescriptionDetails>
          <div className="flex flex-row gap-2 items-center">
            <div>Steven Benitez</div>
            <div>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button plain onClick={handleNameChange}>
                    <PenIcon/>
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  Update Name
                </TooltipContent>
              </Tooltip>
            </div>
          </div>
        </DescriptionDetails>

        <DescriptionTerm>Contact Information</DescriptionTerm>
        <DescriptionDetails>
          (666) 777-8888<br/>
          steven@slashpine.tech
        </DescriptionDetails>

        <DescriptionTerm>Mailing Address</DescriptionTerm>
        <DescriptionDetails>
          914 Railroad Ave.<br/>
          Ste 2<br/>
          Tallahassee, FL 32310
        </DescriptionDetails>
      </DescriptionList>

      <Fieldset>
        <Legend>
          This application process uses personal information to run a credit check (soft inquiry). Deposit(s) can be waived if credit requirements are met as determined by the credit check.
        </Legend>

        <RadioGroup>
          <RadioField>
            <Radio value="agree" />
            <Label>I authorize Talquin Electric Cooperative to use my personal information to run a credit check to waive deposit(s) if credit requirements are met.</Label>
          </RadioField>

          <RadioField>
            <Radio value="disagree" />
            <Label>I do not authorize Talquin Electric Cooperative to run a credit check and hereby understand that I must come in to a Member Services location to complete my application.</Label>
          </RadioField>
        </RadioGroup>
      </Fieldset>

      <ButtonGroup>
        <Button to="/applications/$application-id/identity-check" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
